import AddIcon from '@mui/icons-material/Add'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import MenuIcon from '@mui/icons-material/Menu'
import ExecuteIcon from '@mui/icons-material/PlayArrow'
import { CircularProgress } from '@mui/material'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import * as React from 'react'

export const FloatActionButton = (props?: {
  onCancelClick?: () => void,
  onConfirmClick?: () => void,
  onDeleteClick?: () => void,
  onAddClick?: () => void,
  onEditClick?: () => void,
  onExecuteClick?: () => void,
  icon?: React.ReactNode,
  progress?: Boolean,
}) => {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return <SpeedDial
    ariaLabel="SpeedDial controlled open example"
    sx={{ position: 'absolute', bottom: 16, right: 16 }}
    icon={
      props?.icon && props?.progress || props?.progress ? <CircularProgress size={30} style={{ color: 'white' }} /> : props?.icon ? props?.icon : <MenuIcon />
    }
    onClose={handleClose}
    onOpen={handleOpen}
    open={open}>

    {props?.onCancelClick && <SpeedDialAction
      icon={
        <CloseIcon onClick={() => {
          handleClose()
          if (props?.onCancelClick)
            props.onCancelClick()
        }} />
      }
      onClick={handleClose}
    />}

    {props?.onConfirmClick && <SpeedDialAction
      icon={
        <CheckIcon style={{
          backgroundColor: 'transparent',
        }}
          onClick={() => {
            handleClose()
            if (props?.onConfirmClick)
              props.onConfirmClick()
          }} />}
      onClick={handleClose}
    />}

    {props?.onDeleteClick && <SpeedDialAction
      icon={
        <DeleteIcon onClick={() => {
          handleClose()
          if (props.onDeleteClick)
            props.onDeleteClick()
        }} />
      }
      onClick={handleClose}
    />}

    {props?.onAddClick && <SpeedDialAction
      icon={
        <AddIcon onClick={() => {
          handleClose()
          if (props.onDeleteClick)
            props.onDeleteClick()
        }} />
      }
      onClick={handleClose}
    />}

    {props?.onEditClick && <SpeedDialAction
      icon={
        <EditIcon onClick={() => {
          handleClose()
          if (props.onEditClick)
            props.onEditClick()
        }} />
      }
      onClick={handleClose}
    />}

    {props?.onExecuteClick && <SpeedDialAction
      icon={
        <ExecuteIcon onClick={() => {
          handleClose()
          if (props.onExecuteClick)
            props.onExecuteClick()
        }} />
      }
      onClick={handleClose}
    />}

  </SpeedDial>
}
